import { NamedObject } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a NamedObject.
 *
 * @param obj - The value to check
 * @returns True if the value is a NamedObject
 */
export const isNamedObject = (obj: unknown): obj is NamedObject => {
  // Check object
  if (!isObjectRecord(obj)) return false;
  // Check properties exist
  const chkObj = obj as NamedObject;
  if (typeof chkObj.name !== "string") return false;
  if (chkObj.description !== undefined && typeof chkObj.description !== "string") return false;
  if (chkObj.label !== undefined && typeof chkObj.label !== "string") return false;
  // Everything is good
  return true;
};
